// removed by extract-text-webpack-plugin
module.exports = {"pgd":"pgd","dashboard-chart-list":"dashboard-chart-list","report-chart":"report-chart","ant-col-8":"ant-col-8"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pgd/dashboard/Index.scss
// module id = 941
// module chunks = 0